module.exports = __webpack_public_path__ + "img/button_watchVideo.154eb109.png";